'use client';

import { useEffect } from 'react';
import prismicExperimentImpressionGTMEvent, {
    type PrismicExperimentImpressionGTMEvent,
} from '@app/lib/events/prismic-experiment-impression.gtm';

type PrismicExperimentTrackingProps = PrismicExperimentImpressionGTMEvent;

const trackedImpressions = new Set<string>();

/**
 * Drop-in tracker for Prismic A/B components. Renders nothing and fires a
 * single `prismic_experiment_impression` dataLayer event when its variation is
 * shown. Impressions are de-duplicated per experiment + variation for the
 * lifetime of the page so re-renders do not double count.
 */
export default function PrismicExperimentTracking({
    experimentName,
    variationName,
    variationId,
    componentName,
    locale,
}: PrismicExperimentTrackingProps) {
    useEffect(() => {
        const impressionKey = `${locale ?? ''}::${experimentName}::${variationId ?? variationName}`;

        if (trackedImpressions.has(impressionKey)) {
            return;
        }
        trackedImpressions.add(impressionKey);

        prismicExperimentImpressionGTMEvent({
            experimentName,
            variationName,
            variationId,
            componentName,
            locale,
        });
    }, [experimentName, variationName, variationId, componentName, locale]);

    return null;
}
